import React, { useEffect, useState } from 'react'
import IP_URL from '../connect'
import styled, {keyframes} from 'styled-components'
import { useSelector } from 'react-redux'
import { selectUser } from '../../Redux/currentUserSlice'
import Navbar from '../Navbar'
import Footer from '../Footer'

const Main = styled.div`

`

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;


const Container = styled.div`
  margin: 20px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  width: 95%;
  border-radius: 10px;
  background-color: #ffffff;
  animation: ${fadeIn} 0.4s ease-in;
  overflow-x: auto;
`;

const Table = styled.table`
  border-collapse: collapse;
  background-color: #fdfdfd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;

  th, td {
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  th {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
  }

  tbody tr {
    transition: background 0.2s ease;
  }

  tbody tr:nth-child(odd) {
    background-color: #cce5f8ff;
  }

  tbody tr:hover {
    background-color: #e3f2fd;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    th, td {
      padding: 6px 8px;
    }
  }
`;

const LoadingSpinner = styled.div`
  margin: 40px auto;
  font-size: 20px;
  color: #1976d2;
  text-align: center;
`;

const AdminUserLogs = () => {
    const { token } = useSelector(selectUser);
    const [logs, setLogs] = useState([]);

    const fetchLogs = async ()=> {
        try{
            const res = await fetch(`${IP_URL}/meter/user-logs`, {
                method: 'GET',
                headers:{
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

const data = await res.json();
setLogs(data);
console.log("UserLogs", data)
        }catch(err){
console.error("Error fetching user logs:", err);
        }
    }

    useEffect(() => {
        fetchLogs();
    }, [token]);
  return (
  <Main>
    <Navbar/>
    <Container>
<Table>
    <thead>
        <tr>
            <th>userName</th>
            <th>uniqueKey</th>
            <th>ip</th>
            <th>location</th>
            <th>Date</th>
        </tr>
    </thead>
    <tbody>
        {logs.map((log) => (
          <tr key={log._id}>
            <td>{log.userName}</td>
            <td>{log.uniqueKey}</td>
            <td>{log.ip}</td>
            <td>{log.location?.city}</td>
            <td>{new Date(log.loginTime).toLocaleString()}</td>
          </tr>
        ))}
    </tbody>
</Table>
    </Container>
    <Footer/>
  </Main>
  )
}

export default AdminUserLogs